import React, { useState } from 'react';
import { css } from '@emotion/core';
import { assign as _assign, get as _get } from 'lodash-es';
import PropagateLoader from 'react-spinners/PropagateLoader';

const colorConfig = _get(window, 'compatioConfig.dcColorConfig');
// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  text-align: center;
  margin: 100px 0;
  color: #000;
`;

const Spinner = () => {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState();
  // colorConfig.spinnerColor ? colorConfig.spinnerColor : 'lightblue'

  return (
    <PropagateLoader color={color} loading={loading} css={override} size={15} />
  );
};

export default Spinner;
